import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
	state: {
		lotsList: [],
		typesArr: [],
		vehicleTypes: [],
		providersArr: [],
		brokersArr: [],
		warehousesArr: [],
		crossings: [],
		clearances: [],
		cargoTypes: [],
		currencies: []
	},
	actions,
	mutations,
	getters
};
